<template>
  <div class="media-nkn-header">
    <div class="nkn-user" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
      <div class="icon-menu">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <div class="nkn-nav-menu dropdown-menu">
      <div class="list">
        <div class="title">{{$t("header.nav.tab6")}}</div>
        <a
          href="https://dataride.nkn.org"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab8")}}</a>
        <router-link
          tag="a"
          :to="langTo('/ncdn/')"
          class="header-tab-block"
          active-class="active"
        >{{$t("header.nav.tab7")}}</router-link>
        <a
          :href="langTo('/nMobile/')"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab11")}}</a>
        <a
          :href="langTo('/nMobile-pro/')"
          target="_blank"
          class="header-tab-block drop-item"
        >{{$t("header.nav.tab13")}}</a>
      </div>
      <router-link
        tag="a"
        to="/developer/"
        class="header-tab-block"
        active-class="active"
      >{{$t("header.nav.tab1")}}</router-link>
      <router-link
        tag="a"
        to="/miner/"
        class="header-tab-block"
        active-class="active"
      >{{$t("header.nav.tab2")}}</router-link>
      <!--      <router-link tag="a" to="/partner/" class="header-tab-block" active-class="active">{{$t("header.nav.tab3")}}</router-link>-->
      <!-- <router-link
        tag="a"
        to="/news/"
        class="header-tab-block"
        active-class="active"
      >{{$t("header.nav.tab12")}}</router-link>-->
      <a
        :href="langToBlog()"
        target="_blank"
        class="header-tab-block drop-item"
      >{{$t("header.nav.tab12")}}</a>
      <a
        :href="$url.FOOTER_LINK.community.forum"
        target="_blank"
        class="header-tab-block"
        active-class="active"
      >
        <span>{{$t("footer.community.tab7")}}</span>
      </a>
      <!--      <router-link tag="a" to="/about/" class="header-tab-block" active-class="active">{{$t("header.nav.tab5")}}</router-link>-->
      <div class="list">
        <div class="title">{{$t("header.nav.tab5")}}</div>
        <a
          @click="scrollTo(langTo('/about/'),'#team')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab9")}}</a>
        <a
          @click="scrollTo(langTo('/about/'),'#partner')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab3")}}</a>
        <a
          @click="scrollTo(langTo('/about/'),'#roadmap')"
          class="header-tab-block drop-item"
          active-class="active"
        >{{$t("header.nav.tab10")}}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    langTo(path) {
      let root = "";
      if (!!this.$route.params.lang) {
        root = `/${this.$route.params.lang}`;
      }
      return `${root}${path}`;
    },
    langToBlog() {
      let root = "";
      if (this.$route.params.lang === "zh") {
        return `https://blog.nkn.org/?cat=131`;
      } else {
        return `https://blog.nkn.org`;
      }
    },
    scrollTo(path, target) {
      this.$router.push(path);
      this.$nextTick(() => {
        document.getElementById(target).scrollIntoView();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.media-nkn-header {
  display: none;
  &.open {
    .icon-menu {
      .line {
        border-color: #1791f2 !important;
      }
    }
  }
  @media screen and (max-width: 768px) {
    display: flex;
    .nkn-user {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .nkn-nav-menu.dropdown-menu {
    width: 120px;
    min-width: auto;
    padding: 0 10px;
    right: 10px;
    left: auto;
    .header-tab-block {
      display: block;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      padding: 4px 0;
      margin: 0 auto;
      font-weight: bold;
    }

    .list {
      display: flex;
      flex-direction: column;
      text-align: center;
      font-size: 12px;
      padding-top: 8px;
      padding-bottom: 8px;
      .title {
        padding-top: 4px;
        color: #757575;
        font-size: 9px;
      }
    }
    a + a {
      /*border-top: 1px solid #ccc;*/
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header/nknHeaderNavMedia.vue